const METHOD_NAME_PREFIX = 'KatalComponent';
const METRIC_KEY = 'totalConnectedOnPage';
let totalConnectedComponentCount = 0;
let individualConnectedComponentCounts = {};
export function collectComponentMetrics(publisher, sushiDriver) {
  sushiDriver.beforeUnload(() => {
    publishMetrics(publisher);
  });
  window.addEventListener('katal-component-connected', e => {
    const tag = e.detail.element.tagName.toLowerCase();
    incrementCounters(tag);
  });
}
function incrementCounters(tag) {
  ++totalConnectedComponentCount;
  const individualCount = individualConnectedComponentCounts[tag] || 0;
  individualConnectedComponentCounts[tag] = individualCount + 1;
}
function publishMetrics(publisher) {
  const totalCountPublisher = publisher.newChildPublisher({
    methodName: `${METHOD_NAME_PREFIX}:all`
  });
  totalCountPublisher.publishCounterMonitor(METRIC_KEY, totalConnectedComponentCount);
  const uniqueTagCountPublisher = publisher.newChildPublisher({
    methodName: `${METHOD_NAME_PREFIX}:uniqueTags`
  });
  uniqueTagCountPublisher.publishCounterMonitor(METRIC_KEY, Object.keys(individualConnectedComponentCounts).length);
  for (const tag in individualConnectedComponentCounts) {
    const action = publisher.newChildPublisher({
      methodName: `${METHOD_NAME_PREFIX}:${tag}`
    });
    action.publishCounterMonitor(METRIC_KEY, individualConnectedComponentCounts[tag]);
  }
}
export function reset() {
  totalConnectedComponentCount = 0;
  individualConnectedComponentCounts = {};
}
//# sourceMappingURL=component-metrics.js.map